const prod = require('./products.json');
console.log(prod)